import axios from 'axios'
import {VueAxios} from './axios'
import {notification} from 'ant-design-vue'

/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/jeecg-boot'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
let apiBaseUrl = window._CONFIG['domianURL'] || "/jeecg";
//console.log("apiBaseUrl= ",apiBaseUrl)
// 创建 axios 实例
const service = axios.create({
    //baseURL: '/jeecg-boot',
    baseURL: apiBaseUrl, // api base_url
    timeout: 30000 // 请求超时时间
})

const err = (error) => {
    if (error.response) {
        let that = this;
        let data = error.response.data
        switch (error.response.status) {
            case 403:
                notification.error({message: '系统提示', description: '拒绝访问', duration: 4})
                break
            case 500:
                //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
                // if(token && data.message=="Token失效，请重新登录"){
                // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
                // store.dispatch('Logout').then(() => {
                //     window.location.reload()
                // })
                // Modal.error({
                //   title: '登录已过期',
                //   content: '很抱歉，登录已过期，请重新登录',
                //   okText: '重新登录',
                //   mask: false,
                //   onOk: () => {
                //     store.dispatch('Logout').then(() => {
                //       Vue.ls.remove(ACCESS_TOKEN)
                //       try {
                //         let path=that.$route.path;
                //         if(path.indexOf('/user/login')==-1){
                //           window.location.reload()
                //         }
                //       }catch (e) {
                //         window.location.reload()
                //       }
                //     })
                //   }
                // })
                // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
                // }
                break
            case 404:
                notification.error({message: '系统提示', description: '很抱歉，资源未找到!', duration: 4})
                break
            case 504:
                notification.error({message: '系统提示', description: '网络超时'})
                break
            default:
                notification.error({
                    message: '系统提示',
                    description: data.message,
                    duration: 4
                })
                break
        }
    }
    return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
    if (config.method == 'get') {
        if (config.url.indexOf("sys/dict/getDictItems") < 0) {
            config.params = {
                _t: Date.parse(new Date()) / 1000,
                ...config.params
            }
        }
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
    return response.data
}, err)

const installer = {
    vm: {},
    install(Vue, router = {}) {
        Vue.use(VueAxios, router, service)
    }
}

export {
    installer as VueAxios,
    service as axios
}
